import { Helmet } from "react-helmet-async";

const SITE = "https://allthingssocialimpact.com";
const DEFAULTS = {
  siteName: "All Things Social Impact",
  defaultTitle: "All Things Social Impact | Andrea Kanaris - Social Risk & Impact Advisory",
  defaultDescription: "Andrea Kanaris - strategic advisory, corporate services and a 12-module practitioner Toolbox for Social Impact Assessment, community engagement and social risk. AU & US.",
  defaultImage: `${SITE}/brand-logo.webp`,
};

/**
 * Drop-in SEO wrapper. Pass `title` (page-specific), `description`, `path`, optional `image`.
 * For blog posts pass `ogType="article"` + optional `publishedTime` and `articleTag`.
 */
export default function Seo({
  title,
  description,
  path = "",
  image,
  noindex = false,
  jsonLd,
  ogType = "website",
  publishedTime,
  articleTag,
}) {
  const fullTitle = title ? `${title} | ${DEFAULTS.siteName}` : DEFAULTS.defaultTitle;
  const desc = description || DEFAULTS.defaultDescription;
  const url = `${SITE}${path || ""}`;
  const img = image || DEFAULTS.defaultImage;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={DEFAULTS.siteName} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      {ogType === "article" && publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {ogType === "article" && <meta property="article:author" content="Andrea Kanaris" />}
      {ogType === "article" && articleTag && <meta property="article:tag" content={articleTag} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
